import { useEffect } from "react";

const DEFAULT_TITLE = "WeAutomate — From your idea to a shippable product.";
const DEFAULT_DESCRIPTION = "WeAutomate — India's applied-intelligence company. We engineer hardware, build software, and automate the spaces businesses run in. One partner, from first sketch to shipped product.";

function setMeta(selectorAttr, name, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${selectorAttr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(selectorAttr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

// Sets document.title and, if a description is provided, updates
// <meta name="description"> and the og:title / og:description tags for
// share cards. Backward compatible with the one-arg signature; pages
// that do not pass a description leave the current global one from
// index.html untouched.
export function usePageTitle(title, description) {
  useEffect(() => {
    const fullTitle = title ? `${title} — WeAutomate` : DEFAULT_TITLE;
    document.title = fullTitle;
    setMeta("property", "og:title", fullTitle);
    setMeta("name", "twitter:title", fullTitle);
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
    return () => {
      document.title = DEFAULT_TITLE;
      setMeta("name", "description", DEFAULT_DESCRIPTION);
    };
  }, [title, description]);
}
